export default __webpack_public_path__ + "static/media/paintbrush.b385742c.svg";